import React from 'react';
import SignInForm from '../components/SignInForm';

function SignIn() {
  return (
    <main style={{ padding: '20px' }}>
      <SignInForm />
    </main>
  );
}

export default SignIn;
